// Load dependencies
var angular = require('angular');
window.angular = angular;
require('angular-animate');
require('angular-resource');
require('angular-cookies');
require('angular-growl-v2');
require('angular-ui-router');
require('angular-google-analytics');
require('ng-meta');

// Our code
require('@sonyatv/playlistclientbundle');
require('@sonyatv/playlistpitchclientbundle');
require('@sonyatv/userclientbundle');
require('@sonyatv/contactclientbundle');
require('@sonyatv/countryclientbundle');
require('@sonyatv/play-licensingclientbundle');
require('@sonyatv/mediaclientbundle');
require('@sonyatv/mediastatsclientbundle');
require('@sonyatv/loginclientbundle');
require('@sonyatv/loginextraclientbundle');
require('@sonyatv/publicplaylistbundle');
require('@sonyatv/smfcoreclientbundle');
require('@sonyatv/ngtools');
require('@sonyatv/ngplayer');
require('angular-ui-tinymce');
require('@sonyatv/play-appbundle');
require('@sonyatv/play-loginclientbundle');
require('@sonyatv/play-registrationclientbundle');
require('@sonyatv/play-mediaclientbundle');
require('@sonyatv/play-playlistclientbundle');
require('@sonyatv/play-playlistpitchclientbundle');
require('@sonyatv/play-playuibundle');
require('@sonyatv/play-userclientbundle');


// Styles
require('../../src/Shared/PlayUiBundle/Resources/styles/main.less');


// WEBPACK FOOTER //
// ./assets/js/app.js